export default class DealerType {
  constructor(params) {
    this.id = params.id ? params.id : 0;
    this.dealerType = params.dealerType ? params.dealerType : "";
    this.minNumServices = params.minNumServices ? params.minNumServices : 0;
    this.servicesinPeriod = params.servicesinPeriod
      ? params.servicesinPeriod
      : 0;
    this.overridePercent = params.overridePercent ? params.overridePercent : 0;
  }
}
